// src/features/objectifs/routes.ts
import { lazy } from 'react';
import { Target } from 'lucide-react';
import { RouteConfig } from '../../types/routing.types';

const ObjectifsDashboard = lazy(() => import('./components/ObjectifsDashboard'));

export const objectifsRoutes: RouteConfig[] = [
  {
    path: '/objectifs/*',
    component: ObjectifsDashboard,
    label: 'Objectifs',
    icon: Target,
    showInNav: true,
    navPath: '/objectifs',  // Path réel pour la navigation (sans wildcard)
  },
];
